import { AppContext } from '../schema/AppContext';
import { ListenerType } from '../schema/ListenerType';

/**
 * Method to create a new app context for a workflow.
 */
export function createAppContext(
    cId?: string,
    defaultPayload?: any,
    listeners?: ListenerType[]
): AppContext {
    return new AppContext(cId, defaultPayload, listeners);
}
